import { ReactElement } from "react"

interface MinimalAuthLayoutProps {
  form: ReactElement
}

const MinimalAuthLayout = ({ form }: MinimalAuthLayoutProps) => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="max-w-md w-full px-4">{form}</div>
  </div>
)

export default MinimalAuthLayout
